import { useState, useRef, useEffect } from "react";
const BASE = "https://support.gs-group.fr/api";

export default function MFAVerify({ userId, onSuccess }) {
  const [code, setCode]    = useState(["","","","","",""]);
  const [error, setError]  = useState("");
  const [loading, setLoad] = useState(false);
  const inputs = useRef([]);

  useEffect(()=>{ inputs.current[0]?.focus(); },[]);

  const handleChange = (i, val) => {
    if (!/^\d*$/.test(val)) return;
    const n = [...code]; n[i] = val.slice(-1); setCode(n);
    if (val && i<5) inputs.current[i+1]?.focus();
    if (n.every(c=>c) && val) verify(n.join(""));
  };

  const handleKey = (i, e) => {
    if (e.key==="Backspace" && !code[i] && i>0) inputs.current[i-1]?.focus();
  };

  const verify = async (fullCode) => {
    setLoad(true); setError("");
    const res = await fetch(`${BASE}/auth/verify-mfa`,{
      method:"POST",headers:{"Content-Type":"application/json"},
      body:JSON.stringify({user_id:userId,code:fullCode})
    }).then(r=>r.json());
    setLoad(false);
    if (res.token) onSuccess(res);
    else { setError(res.error||"Code invalide"); setCode(["","","","","",""]); inputs.current[0]?.focus(); }
  };

  return (
    <div style={{minHeight:"100vh",background:"#0d1117",display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:"#161b27",border:"1px solid #1e2a3a",borderRadius:16,width:400,padding:36,textAlign:"center"}}>
        <div style={{fontSize:40,marginBottom:12}}>🔑</div>
        <div style={{fontSize:20,fontWeight:800,color:"#fff",marginBottom:6}}>Vérification</div>
        <div style={{fontSize:13,color:"#5a6a7e",marginBottom:28}}>Code à 6 chiffres envoyé par email</div>
        <div style={{display:"flex",gap:10,justifyContent:"center",marginBottom:20}}>
          {code.map((c,i)=>(
            <input key={i} ref={el=>inputs.current[i]=el}
              value={c} onChange={e=>handleChange(i,e.target.value)} onKeyDown={e=>handleKey(i,e)}
              maxLength={1} type="text" inputMode="numeric"
              style={{width:48,height:56,textAlign:"center",fontSize:24,fontWeight:800,fontFamily:"monospace",
                background:"#0d1117",border:`2px solid ${c?"#5b6ef8":"#1e2a3a"}`,borderRadius:12,color:"#fff",outline:"none"}}/>
          ))}
        </div>
        {error&&<div style={{fontSize:12,color:"#ef4444",marginBottom:12}}>{error}</div>}
        {loading&&<div style={{fontSize:13,color:"#5a6a7e"}}>⏳ Vérification...</div>}
        <div style={{fontSize:11,color:"#5a6a7e",marginTop:16}}>Pas reçu ? Vérifiez vos spams.</div>
      </div>
    </div>
  );
}
